var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-main"},[_c('span',{class:_vm.textColor},[_vm._v("简体中文")]),_c('i',{staticClass:"drop-down"})])
}
var staticRenderFns = []

export { render, staticRenderFns }